import { AxiosRequestConfig } from "axios";

import { addToasterActionData } from "hooks/useToasterFromActionData";
import scraperApi, { ApiError, ApiErrorResponse } from "api";
import { ActiveCouponsDataRouteType } from "routes/data-routes/billing-data/coupons/active-coupons/route.meta";


export const removeCouponAction: (couponCode: string, opts?: AxiosRequestConfig) => ReturnType<NonNullable<ActiveCouponsDataRouteType["route"]["action"]>> =
  async (couponCode, opts) => {
    try {
      const activeCoupons = await scraperApi.billing.coupons.deleteCoupon(couponCode, opts);
      return addToasterActionData(
        { activeCoupons },
        {
          toastId: "promo-code-removed",
          type: "success",
          title: "Promo Code Removed",
          description: "Your promo code has been successfully removed from your subscription."
        }
      );
    } catch (err) {
      const error = err as ApiError<ApiErrorResponse>;
      return addToasterActionData(
        { error: { message: error.message || "Failed to remove coupon" } },
        {
          toastId: "remove-coupon-error",
          type: "error",
          title: "Coupon Error",
          description: error.message || "Failed to remove coupon"
        }
      );
    }
  };
